import { Separator } from '@bpinternal/ui-kit-next'
import { ReactNode } from 'react'

export const PageSection = ({
  title,
  children,
  actions,
  ...props
}: {
  title: ReactNode
  children?: ReactNode
  actions?: ReactNode
  className?: string
}) => {
  return (
    <div {...props} className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <p className="text-base font-medium">{title}</p>
        <div>{actions}</div>
      </div>
      <Separator />
      {children}
    </div>
  )
}
